import { Formik } from "formik";
import ErrorMessage from "../../../form/ErrorMessage";
import { createOfferSchema } from "../../../../utils/schema";
import {
  editOffer,
  fetchAllCoachOffers,
} from "../../../../redux/features/coach/actions/coachAction";

const EditOfferModal = ({ onClose, dispatch, data }) => {
  const initialValues = {
    offer_title: data?.offer_title || "",
    purpose: data?.purpose || "",
    offer_type: data?.offer_type || "Discovery Call (Free)",
    offer_format: data?.offer_format || "",
    duration: data?.duration || 30,
    price: data?.price || "",
    additional_notes: data?.additional_notes || "",
  };

  const handleUpdate = (values) => {
    const callback = (response) => {
      dispatch(fetchAllCoachOffers());
      onClose();
    };
    dispatch(editOffer({ payload: values, id: data?.offer_id, callback }));
  };

  return (
    <div
      className="modal d-block ct_congratulation_modal_fade ct_reactivate_account"
      tabIndex="-1"
    >
      <div class="modal-dialog modal-dialog-centered ct_modal-dialog">
        <div class="modal-content">
          <div className="modal-header border-0">
            <h4 className="ct_fs_16 ct_darkblue_text mb-0">
              Edit Offer Details
            </h4>
            <button
              type="button"
              className="btn-close ct_circle_close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body px-0 ct_mt_20 pt-0">
            <Formik
              initialValues={initialValues}
              validationSchema={createOfferSchema}
              onSubmit={(values, actions) => {
                handleUpdate(values);
              }}
              enableReinitialize
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                resetForm,
              }) => (
                <form className="ct_modal_scroll ct_custom_scroll px-4 pb-3 ">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group mb-4">
                        <label className="ct_fs_14 ct_darkblue_text mb-2">
                          Offer Title
                        </label>
                        <input
                          value={values?.offer_title}
                          id="offer_title"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          type="text"
                          className="form-control ct_fs_12 ct_input"
                          placeholder=" Offer title"
                        />
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"offer_title"}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group mb-4">
                        <label className="ct_fs_14 ct_darkblue_text mb-2">
                          Purpose
                        </label>
                        <input
                          value={values?.purpose}
                          id="purpose"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          type="text"
                          className="form-control ct_fs_12 ct_input"
                          placeholder=" Purpose"
                        />
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"purpose"}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-4">
                        <label className="ct_fs_14 ct_darkblue_text mb-2">
                          Type
                        </label>
                        <div className="d-flex flex-column gap-2 position-relative">
                          <select
                            className="form-control ct_fs_12 ct_input"
                            value={values?.offer_type}
                            id="offer_type"
                            onBlur={handleBlur}
                            onChange={handleChange}
                          >
                            <option value="Discovery Call (Free)">
                              Discovery Call (Free)
                            </option>
                            <option value="Clarity Boost">Clarity Boost</option>
                            <option value="Growth Pro">Growth Pro</option>
                            <option value="Deep Dive">Deep Dive</option>
                            <option value="Team Coaching">Team Coaching</option>
                            <option value="Group Coaching">Group Coaching</option>
                          </select>
                          <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                        </div>
                      </div>
                      <ErrorMessage
                        errors={errors}
                        touched={touched}
                        fieldName={"offer_type"}
                      />
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-4">
                        <label className="ct_fs_14 ct_darkblue_text mb-2">
                          Duration
                        </label>
                        <div className="d-flex flex-column gap-2 position-relative">
                          <select
                            className="form-control ct_fs_12 ct_input"
                            value={values?.duration}
                            id="duration"
                            onBlur={handleBlur}
                            onChange={handleChange}
                          >
                            <option value={30}>30 minutes</option>
                            <option value={60}>60 minutes</option>
                            <option value={75}>75 minuteso</option>
                            <option value={90}>90 minutes</option>
                          </select>
                          <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                        </div>
                      </div>
                      <ErrorMessage
                        errors={errors}
                        touched={touched}
                        fieldName={"duration"}
                      />
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-4">
                        <label className="ct_fs_14 ct_darkblue_text mb-2">
                          Format
                        </label>
                        <div className="d-flex flex-column gap-2 position-relative">
                          <select
                            className="form-control ct_fs_12 ct_input"
                            value={values?.offer_format}
                            id="offer_format"
                            onBlur={handleBlur}
                            onChange={handleChange}
                          >
                            <option value="1:1"> 1 : 1 </option>
                            <option value="In-person">In-person</option>
                            <option value="Hybrid">Hybrid</option>
                            <option value="Group Call">Group Call </option>
                          </select>
                          <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                        </div>
                      </div>
                      <ErrorMessage
                        errors={errors}
                        touched={touched}
                        fieldName={"offer_format"}
                      />
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-4">
                        <label className="ct_fs_14 ct_darkblue_text mb-2">
                          Price
                        </label>
                        <input
                          value={values?.price}
                          id="price"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          type="text"
                          className="form-control ct_fs_12 ct_input"
                          placeholder=" Price"
                        />
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"price"}
                        />
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="form-group mb-4">
                        <label className="ct_fs_14 ct_darkblue_text mb-2">
                          Additional Notes
                        </label>
                        <textarea
                          value={values?.additional_notes}
                          id="additional_notes"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          className="form-control ct_input h-auto ct_fs_12"
                          rows={4}
                          placeholder="Any extra information or special conditions. (max 1000 characters)"
                        ></textarea>
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"additional_notes"}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-3 justify-content-end pt-4">
                    <button
                      className="ct_sky_blue_btn ct_fs_14 ct_yellow_btn ct_outline_grey  px-5 py-2"
                      style={{ borderColorL: "#53586252" }}
                      type="button"
                      onClick={onClose}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleSubmit}
                      className=" ct_yellow_btn px-5 ct_fs_14 py-2"
                      type="button"
                    >
                      Continue
                    </button>
                  </div>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div >
  );
};

export default EditOfferModal;
